import { SelectOption } from '@fleet-beat/core';

export enum DvirStatusEnum {
  NoDefects = 'safe',
  DefectsCorrected = 'resolved',
  DefectsToBeCorrected = 'unsafe',
}

export const DvirStatusOptions: SelectOption[] = [
  { value: DvirStatusEnum.NoDefects, label: 'No defects' },
  { value: DvirStatusEnum.DefectsToBeCorrected, label: 'Defects need to be corrected' },
  { value: DvirStatusEnum.DefectsCorrected, label: 'Defects corrected' },
];
